import { getFlag } from 'ext/lib/feature-flags';
import { getRegionFromHostname } from './region.web';

/**
 * Check if Auth0 authentication is enabled.
 * EU always uses Auth0. US checks the feature flag.
 */
export const isAuth0Enabled = async (): Promise<boolean> => {
  if (import.meta.env.E2E) return false;

  const region = getRegionFromHostname();
  if (region === 'EU') return true;

  return getFlag('use-auth0-us', true);
};
